import ReactGA from 'react-ga4';

const TRACKING_ID = 'G-DEVCKM9PNY';
const isProduction = window.location.hostname !== 'localhost';

// Initialize Google Analytics
export const initGA = () => {
  if (isProduction) {
    ReactGA.initialize(TRACKING_ID);
    console.log('GA initialized');
  }
};

// Track page views
export const trackPageView = (page) => {
  if (isProduction) {
    ReactGA.send({ hitType: 'pageview', page });
    console.log(`Page viewed: ${page}`);
  }
};

// Track events
export const trackEvent = (category, action, label = null, value = null) => {
  if (isProduction) {
    ReactGA.event({
      category,
      action,
      label,
      value
    });
    console.log(`Event tracked: ${category} - ${action} - ${label || 'N/A'}`);
  }
};

// Track custom user interactions
export const trackInteraction = (eventName, eventParams = {}) => {
  if (isProduction) {
    ReactGA.event(eventName, eventParams);
    console.log(`Custom interaction tracked: ${eventName}`);
  }
};

// Special HIPAA assessment events
export const trackAssessmentStep = (stepNumber, stepName) => {
  if (isProduction) {
    ReactGA.event({
      category: 'Assessment',
      action: 'Step Complete',
      label: `Step ${stepNumber}: ${stepName}`
    });
    console.log(`Assessment step tracked: ${stepNumber} - ${stepName}`);
  }
};

export const trackDeviceSelection = (deviceName, deviceCategory) => {
  if (isProduction) {
    ReactGA.event({
      category: 'Device',
      action: 'Selected',
      label: deviceName,
      deviceCategory
    });
    console.log(`Device selected: ${deviceName} (${deviceCategory})`);
  }
};

export const trackRiskScore = (score, riskLevel) => {
  if (isProduction) {
    ReactGA.event({
      category: 'Assessment',
      action: 'Risk Score',
      label: riskLevel,
      value: Math.round(score)
    });
    console.log(`Risk score tracked: ${score} (${riskLevel})`);
  }
};

export default {
  initGA,
  trackPageView,
  trackEvent,
  trackInteraction,
  trackAssessmentStep,
  trackDeviceSelection,
  trackRiskScore
}; 